import { Icons } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { VerifiedByAll, VerifiedDate } from '../../styled'

type Props = {
  coordinatorVerifiedDate: string
  securityVerifiedDate: string
}

export const VerifiedUser: FC<Props> = ({ coordinatorVerifiedDate, securityVerifiedDate }) => {
  const { t } = useTranslation('user')
  const formatDate = useFormatDate()

  return (
    <div>
      <VerifiedByAll>
        <div>
          <Icons.IconCheckMark />
          <span>{t('verify_user')}</span>
        </div>
      </VerifiedByAll>
      <VerifiedDate>
        {t('coordinatorShort')}: {formatDate(coordinatorVerifiedDate)}
      </VerifiedDate>
      <VerifiedDate>
        {t('securityShort')}: {formatDate(securityVerifiedDate)}
      </VerifiedDate>
    </div>
  )
}
